// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__+QEkN","title":"Header_title__x3ga3"};